import { useState, useEffect, useCallback, useRef } from 'react';

import { readStationPlanningWindows } from './stationAutomationConfigApi';

// Station planning windows: the read-only summary in the Inputs modal, and the gate for
// that modal pre-plan. Plan-independent; `reload` picks up an edit from the editor.
export default function useStationPlanningWindows() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const aliveRef = useRef(true);

  useEffect(() => {
    aliveRef.current = true;
    return () => {
      aliveRef.current = false;
    };
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    const next = await readStationPlanningWindows();
    if (!aliveRef.current) return;
    setFile(next);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return {
    intervals: file?.intervals || [],
    lastUpdatedBy: file?.lastUpdatedBy || null,
    exists: !!file,
    loading,
    reload: load
  };
}
